import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import "../LoginPage/LoginPage.css";
import Logo from "../../assets/images/Logo.png";
import { useNavigate } from "react-router-dom";
import { login } from "../api/api";
import OneSignal from "react-onesignal";
import { v4 as uuidv4 } from "uuid";

const LoginPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [deviceToken, setDeviceToken] = useState("");
  const [jwtsToken, setjwtsToken] = useState("");

  useEffect(() => {
    const generatedToken = uuidv4().replace(/-/g, "").substring(0, 32);
    console.log("Generated Token form login page:", generatedToken);
    setjwtsToken(generatedToken);
    localStorage.setItem("jwtToken", generatedToken);
  }, []);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });

  // const showAlert = (message, callback) => {
  //   Swal.fire({
  //     title: "",
  //     text: message,
  //     icon: "success",
  //     confirmButtonText: "OK",
  //   }).then(() => {
  //     if (callback) callback();
  //   });
  // };
  const showAlert = (message, icon = "success", callback) => {
    Swal.fire({
      title: "",
      text: message,
      icon: icon,
      confirmButtonText: "OK",
    }).then(() => {
      if (callback) callback();
    });
  };

  // const handleSubmit = async (values) => {
  //   values.jwtsecret = jwtsToken;
  //   console.log("values in login0", values);
  //   try {
  //     setIsLoading(true);
  //     const response = await login(values);
  //     console.log("response123456", response);
  //     if (response?.success) {
  //       localStorage.setItem("currentUser", JSON.stringify(response?.data));
  //       switch (response?.data?.profile_completion_status) {
  //         case "gender":
  //           showAlert(response?.message, "success", () => navigate("/gender"));
  //           break;
  //         case "paymentscreen":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/PaymentScreen")
  //           );
  //           break;
  //         case "FinalSubmissionPage":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/FinalSubmissionPage")
  //           );
  //           break;
  //         case "UploadImage":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/UploadImage")
  //           );
  //           break;
  //         case "RegistrationVarification":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/RegistrationVarification")
  //           );
  //           break;

  //         case "uploadDocument":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/DocumentUpload")
  //           );
  //           break;
  //         case "UpdateProfileDetails":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/UpdateProfileDetails")
  //           );
  //           break;
  //         case "Lovelanguage":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/Lovelanguage")
  //           );
  //           break;
  //         case "UpdateMatchPreferences":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/UpdateMatchPreferences")
  //           );
  //           break;
  //         case "cultureReligion":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/CultureReligion")
  //           );
  //           break;
  //         case "interest":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/Interest")
  //           );
  //           break;
  //         case "userAnswersTemperament":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/TemperamentQuestion")
  //           );
  //           break;
  //         case "userAnswersValue":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/ValuesAssessment")
  //           );
  //           break;
  //         case "userAnswersIQ":
  //           showAlert(response?.message, "success", () =>
  //             navigate("/IQAssessment")
  //           );
  //           break;
  //         case "Tab":
  //           // showAlert(response?.message, () => navigate("/Sidebar"));
  //           // if (
  //           //   response?.data?.approve_reject === "approved" &&
  //           //   response?.data?.profile_completion_status === "Tab"
  //           // ) {
  //           //   showAlert(response?.message, () => {
  //           //     window.dispatchEvent(new Event("userLoggedIn"));
  //           //     navigate("/Sidebar");
  //           //   });
  //           // }
  //           //  else {
  //           //   showAlert(response?.message, () =>
  //           //     navigate("/FinalSubmissionPage")
  //           //   );
  //           // }
  //           if (
  //             response?.data?.approve_reject_new_image === "pending" &&
  //             response?.data?.profile_completion_status === "Tab"
  //           ) {
  //             navigate("/DocumentVerification");
  //           } else if (
  //             response?.data?.approve_reject === "approved" &&
  //             response?.data?.profile_completion_status === "Tab" &&
  //             response?.data?.activeSubscriptionStatus !== "0"
  //           ) {
  //             navigate("/Sidebar");
  //           } else if (
  //             response?.data?.approve_reject === "approved" &&
  //             response?.data?.profile_completion_status === "Tab" &&
  //             response?.data?.activeSubscriptionStatus === "0"
  //           ) {
  //             navigate("/SubscriptionBlurPage");
  //           }
  //           break;
  //         default:
  //           showAlert(response?.message, "success", () => navigate("/Tab"));
  //       }
  //     } else {
  //       showAlert(response?.message, "error");
  //     }
  //   } catch (error) {
  //     console.error("Login error:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (values) => {
    values.jwtsecret = jwtsToken;
    console.log("values in login0", values);
    try {
      setIsLoading(true);
      const response = await login(values);
      console.log("response123456", response);
      if (response?.success) {
        localStorage.setItem("currentUser", JSON.stringify(response?.data));
        switch (response?.data?.profile_completion_status) {
          case "gender":
            showAlert(response?.message, "success", () => navigate("/gender"));
            break;
          case "paymentscreen":
            showAlert(response?.message, "success", () =>
              navigate("/PaymentScreen")
            );
            break;
          case "FinalSubmissionPage":
            showAlert(response?.message, "success", () =>
              navigate("/FinalSubmissionPage")
            );
            break;
          case "UploadImage":
            showAlert(response?.message, "success", () =>
              navigate("/UploadImage")
            );
            break;
          case "RegistrationVarification":
            showAlert(response?.message, "success", () =>
              navigate("/RegistrationVarification")
            );
            break;

          case "uploadDocument":
            showAlert(response?.message, "success", () =>
              navigate("/DocumentUpload")
            );
            break;
          case "UpdateProfileDetails":
            showAlert(response?.message, "success", () =>
              navigate("/UpdateProfileDetails")
            );
            break;
          case "Lovelanguage":
            showAlert(response?.message, "success", () =>
              navigate("/Lovelanguage")
            );
            break;
          case "UpdateMatchPreferences":
            showAlert(response?.message, "success", () =>
              navigate("/UpdateMatchPreferences")
            );
            break;
          case "cultureReligion":
            showAlert(response?.message, "success", () =>
              navigate("/CultureReligion")
            );
            break;
          case "interest":
            showAlert(response?.message, "success", () =>
              navigate("/Interest")
            );
            break;
          case "userAnswersTemperament":
            showAlert(response?.message, "success", () =>
              navigate("/TemperamentQuestion")
            );
            break;
          case "userAnswersValue":
            showAlert(response?.message, "success", () =>
              navigate("/ValuesAssessment")
            );
            break;
          case "userAnswersIQ":
            showAlert(response?.message, "success", () =>
              navigate("/IQAssessment")
            );
            break;
          case "Tab":
            if (
              response?.data?.approve_reject_new_image === "pending" &&
              response?.data?.profile_completion_status === "Tab"
            ) {
              navigate("/DocumentVerification");
            } else if (
              response?.data?.approve_reject === "approved" &&
              response?.data?.profile_completion_status === "Tab" &&
              // response?.data?.activeSubscriptionStatus !== "0"
              response?.data?.subscription?.object === "subscription"
            ) {
              console.log("123456789------");
              navigate("/Sidebar");
            } else if (
              response?.data?.approve_reject === "approved" &&
              response?.data?.profile_completion_status === "Tab" &&
              // response?.data?.activeSubscriptionStatus === "0"
              response?.data?.subscription?.object !== "subscription"
            ) {
              console.log("123456789");
              if (response?.data?.subscription_status === "past_due") {
                navigate("/SubscriptionBlurPage", {
                  state: { past_due: "past_due" },
                });
              } else {
                navigate("/SubscriptionBlurPage", {
                  state: { past_due: "" },
                });
              }
              // navigate("/SubscriptionBlurPage");
            }
            break;
          default:
            showAlert(response?.message, "success", () => navigate("/Tab"));
        }
      } else {
        showAlert(response?.message, "error");
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-box">
      <img src={Logo} alt="Logo" className="login-logo" />
      <h1>Login</h1>
      <Formik
        initialValues={{
          email: "",
          password: "",
          jwtsecret: jwtsToken,
          type: "user",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="login-form">
            <div className="loginform-group">
              <label>Email</label>
              <Field
                type="email"
                name="email"
                className="form-input"
                // placeholder="Enter your email"
              />
              <ErrorMessage
                name="email"
                component="div"
                className="error-message"
              />
            </div>
            <div className="loginform-group">
              <label>Password</label>
              <Field
                type="password"
                name="password"
                className="form-input"
                // placeholder="Enter your password"
              />
              <ErrorMessage
                name="password"
                component="div"
                className="error-message"
              />
            </div>
            <button
              type="submit"
              className="login-button"
              disabled={isSubmitting || isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </button>
          </Form>
        )}
      </Formik>
      <div className="forgotdiv">
        <p>
          Forgot Password?
          <span
            className="forgottext"
            onClick={() => navigate("/ForgotPassword")}
          >
            Click here!
          </span>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
